<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <br>
                        <i class="bi bi-chevron-left" onclick="window.location.href = '/setting'"></i>
                    </div>
                    <div class="col text-center" style="padding-top: 25px;">
                        <h5>ログアウト</h5>
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <br />
            <div class="container" style="margin-top:30px;">
                <br>
                <br>
                <br>
                <div class="row">
                    <div class="col-2"></div>
                    <div class="col">
                        <div>
                            ログアウトをしてもデータは消えませんので、再度同じアカウントからログインをいただければ、引き続きご利用をいただけます。
                        </div>
                    </div>
                    <div class="col-2"></div>
                </div>
                <br>
                <br>
                <div class="row">
                    <div class="col-2"></div>
                    <div class="col">
                        <div class="d-grid gap-2">
                            <button type="button" class="btn btn-danger" style="padding:12px 0;border-radius: 50px;"
                                @click="logout()">
                                ログアウト
                            </button>
                        </div>
                    </div>
                    <div class="col-2"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getSessionTracker } from "../../event-log/sessionTracker";
export default {
    data() {
        return {
        };
    },
    methods: {
        async logout() {
            localStorage.clear()
            document.cookie = "uid=;path=/; max-age=0"
            getSessionTracker()?.end()
            let response = await axios.get("/api/setting/logout")
                .then((response) => {
                    window.location.href = "/auth"
                })
                .catch((error) => {
                    this.$showErrorToast("ログアウトに失敗しました");
                })
        },
    },
};
</script>
